<p
  class="z-texts-paragraph"
  [innerHTML]="questionData?.content || '' | translateText: 'content' : questionData | formatText | safeHtml"
  [style.color]="(ss.colors | async).text80"
></p>
